import { useState } from 'react'
import { Create, useRedirect, useTranslate } from 'react-admin'
import { useLocation } from 'react-router-dom'

import { BackFromEditorButton } from 'components/common/BackFromEditorButton'

import SchoolClassForm from './SchoolClassForm'

const SchoolClassCreate = (props) => {
    const translate = useTranslate()
    const [isPristineForm, setIsPristineForm] = useState(true)
    const redirect = useRedirect()
    const location = useLocation<{ schoolId?: string }>()
    const { schoolId } = location.state

    const handleRedirect = () => {
        redirect(`/School/${schoolId}/classes`)
    }

    return (
        <>
            <BackFromEditorButton isPristineForm={isPristineForm} />
            <Create
                onSuccess={handleRedirect}
                title={translate('manager.resources.schoolClass.create_a_schoolClass')}
                {...props}
            >
                <SchoolClassForm
                    isPristineForm={isPristineForm}
                    setIsPristineFormCallback={setIsPristineForm}
                />
            </Create>
        </>
    )
}

export default SchoolClassCreate
